import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Alert, AlertType, AlertOptions } from  '../models/alert.model'
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class AlertService {
    private subject = new Subject<Alert>();
    private defaultId = 'default-alert';
    private clearAlertSubject = new Subject<string>();

  constructor(private _sanitizer: DomSanitizer) { }

    // enable subscribing to alerts observable
    onAlert(id = this.defaultId): Observable<Alert> {
        return this.subject.asObservable().pipe(filter(x => x && x.id === id));
    }

  // main alert method
  alert(message: string, type: AlertType, options?: AlertOptions) {
    let parsedMessage = this.parseAlertMessage(message);
    let dateTime = this.parseDateTime(message);

    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const phoneRegex = /tel:(\d{3}-\d{3}-\d{4})/;
    const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4})/g;

    parsedMessage = parsedMessage.replace(urlRegex, '<a href="$1" target="_blank">$1</a>');
    parsedMessage = parsedMessage.replace(phoneRegex, '<a href="tel:$1">$1</a>');
    parsedMessage = parsedMessage.replace(emailRegex, '<a href="mailto:$1">$1</a>');

    let alert = new Alert({
      ...options,
      type
    });
    alert.closeable = options?.hasCloseButton;
    alert.id = type || this.defaultId;
    alert.message = this._sanitizer.bypassSecurityTrustHtml(parsedMessage);
    alert.lastUpdatedDate = dateTime;

    this.subject.next(alert);
  }

  /**
   * Note: The user and the date the broadcast message is last updated is stored in the same column as the message and are appended inside a parenthesis.
   * e.g. "This is a broadcast message (developer 1/4/23 10:01)"
   */

  parseAlertMessage(message: string) {
    let devData = message.match(/\(([^\)]+)\)$/);
    if(devData && devData[0]) {
      return message.replace(devData[0],'').trim();
    }
    return message;
  }

  parseDateTime(message: string) {
    let dateTimeMatch = message.match(/[\d-|/|:]+/g);
    if (dateTimeMatch && dateTimeMatch.length > 0) {
      let dateTimeStr = dateTimeMatch.join(' ');
      return new Date(dateTimeStr);
    }
  }

  // clear alerts
    clear(id = this.defaultId) {
        this.subject.next(new Alert({ id: AlertType.Error }));
        this.subject.next(new Alert({ id: AlertType.Info }));
        this.subject.next(new Alert({ id: AlertType.Warning }));
        localStorage.removeItem('Rapidship:broadcastMessagesClosed' + AlertType.Error);
        localStorage.removeItem('Rapidship:broadcastMessagesClosed' + AlertType.Info);
        localStorage.removeItem('Rapidship:broadcastMessagesClosed' + AlertType.Warning);
    }

  clearByUniqueId(uniqueId:string) {
      return this.clearAlertSubject.next(uniqueId);
  }

  onClear(): Observable<string> {
    return this.clearAlertSubject.asObservable();
  }

}
